module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_5-8d0e675325d0984ede0c663b55b3ec0d.png";